import Accordion from 'accordion-js';

document.addEventListener('DOMContentLoaded', () => {
    const triggers = document.querySelectorAll('.collapse-trigger');
    triggers.forEach(anchor => {
        anchor.addEventListener("click", function (e) {
            e.preventDefault();
        });
    });

    const accordions = Array.from(document.querySelectorAll('.collapse-container'));
    new Accordion(accordions, {
        elementClass: 'collapse',
        triggerClass: 'collapse-trigger',
        panelClass: 'collapse-target',
        duration: 400,
    });
});
